"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IStableCoinFactory__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
        ],
        name: "AddressZero",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "ref",
                type: "uint256",
            },
        ],
        name: "LessThan",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
        ],
        name: "OnlyAdministratorFunction",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldAdmin",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "stableCoinProxy",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "stableCoinProxyAdmin",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "stableCoinContractAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "tokenAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "reserveProxy",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "reserveProxyAdmin",
                        type: "address",
                    },
                ],
                indexed: false,
                internalType: "struct IStableCoinFactory.DeployedStableCoin",
                name: "deployedStableCoin",
                type: "tuple",
            },
        ],
        name: "Deployed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newHederaTokenManager",
                type: "address",
            },
        ],
        name: "HederaTokenManagerAddressAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldAddress",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newAddress",
                type: "address",
            },
        ],
        name: "HederaTokenManagerAddressEdited",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "addressRemoved",
                type: "address",
            },
        ],
        name: "HederaTokenManagerAddressRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "StableCoinFactoryInitialized",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address",
            },
        ],
        name: "addHederaTokenManagerVersion",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address",
            },
        ],
        name: "changeAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "string",
                        name: "tokenName",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "tokenSymbol",
                        type: "string",
                    },
                    {
                        internalType: "bool",
                        name: "freeze",
                        type: "bool",
                    },
                    {
                        internalType: "bool",
                        name: "supplyType",
                        type: "bool",
                    },
                    {
                        internalType: "int64",
                        name: "tokenMaxSupply",
                        type: "int64",
                    },
                    {
                        internalType: "int64",
                        name: "tokenInitialSupply",
                        type: "int64",
                    },
                    {
                        internalType: "int32",
                        name: "tokenDecimals",
                        type: "int32",
                    },
                    {
                        internalType: "address",
                        name: "reserveAddress",
                        type: "address",
                    },
                    {
                        internalType: "int256",
                        name: "reserveInitialAmount",
                        type: "int256",
                    },
                    {
                        internalType: "bool",
                        name: "createReserve",
                        type: "bool",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "keyType",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes",
                                name: "publicKey",
                                type: "bytes",
                            },
                            {
                                internalType: "bool",
                                name: "isED25519",
                                type: "bool",
                            },
                        ],
                        internalType: "struct KeysLib.KeysStruct[]",
                        name: "keys",
                        type: "tuple[]",
                    },
                    {
                        components: [
                            {
                                internalType: "bytes32",
                                name: "role",
                                type: "bytes32",
                            },
                            {
                                internalType: "address",
                                name: "account",
                                type: "address",
                            },
                        ],
                        internalType: "struct IHederaTokenManager.RolesStruct[]",
                        name: "roles",
                        type: "tuple[]",
                    },
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "account",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "allowance",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct IHederaTokenManager.CashinRoleStruct",
                        name: "cashinRole",
                        type: "tuple",
                    },
                    {
                        internalType: "string",
                        name: "metadata",
                        type: "string",
                    },
                    {
                        internalType: "address",
                        name: "proxyAdminOwnerAccount",
                        type: "address",
                    },
                ],
                internalType: "struct IStableCoinFactory.TokenStruct",
                name: "requestedToken",
                type: "tuple",
            },
            {
                internalType: "address",
                name: "stableCoinContractAddress",
                type: "address",
            },
        ],
        name: "deployStableCoin",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "stableCoinProxy",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "stableCoinProxyAdmin",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "stableCoinContractAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "tokenAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "reserveProxy",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "reserveProxyAdmin",
                        type: "address",
                    },
                ],
                internalType: "struct IStableCoinFactory.DeployedStableCoin",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "newAddress",
                type: "address",
            },
        ],
        name: "editHederaTokenManagerAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getHederaTokenManagerAddress",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "removeHederaTokenManagerAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class IStableCoinFactory__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.IStableCoinFactory__factory = IStableCoinFactory__factory;
IStableCoinFactory__factory.abi = _abi;
